export default "__VITE_ASSET__1M$BhXMG__"